module.exports = __webpack_public_path__ + "static/img/feature_3.b4aa4d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/feature_3.png
// module id = YPlV
// module chunks = 0